import { lazy } from 'react';

export const ArticleFormPage = lazy(() => import('./ArticleFormPage'));
